import { Box, Text, Title } from "@mantine/core";
import React from "react";

const SubmitSuccess = () => {
  return (
    <Box>
      <Title>Successfully Removed</Title>
      <Text pt="md">Your job listing has been removed.</Text>
    </Box>
  );
};

export default SubmitSuccess;
